<template>
  <div>
    <Navigation/>
    <!-- 视频合成 -->
    <div class="bg_box">
      <div class="noneBox"></div>
      <div class="box">
        <p class="back" @click="$router.push('/wordNav')">返回</p>

        <div class="ct_box flex">
          <div class="form_upload_box">
            <ai_title ai_title="“智能生成”_视频合成"/>
            <div class="generated_title_box">
              <p class="from_title_new">视频合成</p>
              <ai_switch :select_version="form.select_version" tab1_name="视频版" tab2_name="图文版"
                         @select_versionShow="select_versionShow"/>
            </div>
            <div class="transparent_box" style="padding: 20px 50px">

              <div class="tips_box">
                <div class="tips_title">温馨提醒：</div>
                <div class="tips">
                  <p v-show="form.select_version==='2'">1.合并过程中，背景图片会轮播播放，整体合成视频时长为音频时长；</p>
                  <p v-show="form.select_version==='2'">2.背景图片建议分辨率一致</p>
                  <p v-show="form.select_version==='1'">
                    1.合并过程中，背景视频中的音频会与录音合并，成品仅保留录音音频；</p>
                  <p v-show="form.select_version==='1'">
                    2.合并过程中，已背景视频时长为准，整体合成视频时长为背景视频时长；</p>
                </div>
              </div>
              <div class="box_content_1">
                <!--视频版-背景视频上传-->
                <div class="box_content_1_item" v-show="form.select_version === '1'">
                  <div class="upload_box_1">
                    <span>背景视频</span>
                    <div v-if="form.bgVideoFile === ''" class="upload_box">
                      <el-upload
                          class="upload-demo"
                          action="/api/common/upload"
                          :headers="headers"
                          :before-upload="beforeUploadBgVideo"
                          :on-success="uploadBgVideoSuccess"
                          :on-error="uploadBgVideoError"
                          style="height: 33px;width:130px;overflow: hidden;"
                      >
                        <el-button size="small" type="primary" style="width: 130px" plain>
                          <i class="el-icon-plus"></i>上传视频
                        </el-button>
                      </el-upload>
                    </div>
                    <div v-else class="after_upload">
                      <div class="fileName">{{ bgVideoFile_Name }}</div>
                      <i class="el-icon-error" @click="changeBgVideoFile"></i>
                    </div>
                  </div>
                  <div class="documentationRequirements">
                    <p>（标准：文件大小不超过 500 MB；支持的视频格式：mp4、wmv）</p>
                  </div>
                </div>


                <!--图文版/视频版-录音上传-->
                <div class="box_content_1_item">
                  <div class="upload_box_1">
                    <span>音频上传</span>
                    <div v-if="form.recordingFile === ''">
                      <el-upload
                          class="upload-demo"
                          action="/api/common/upload"
                          :headers="headers"
                          :before-upload="beforeUploadAudio"
                          :on-success="uploadRecordingSuccess"
                          :on-error="uploadAudioError"
                      >
                        <el-button size="small" type="primary" plain><i class="el-icon-plus"></i>上传音频</el-button>
                      </el-upload>
                    </div>
                    <div v-else class="after_upload">
                      <div class="fileName">{{ recordingFile_Name }}</div>
                      <i class="el-icon-error" @click="changeRecordingFile"></i>
                    </div>
                  </div>
                  <div class="documentationRequirements">
                    <p>1.时长不超过一分半</p>
                    <p>2.文件大小不超过120 MB</p>
                    <p>3.支持音频格式为wav、mp3、wma、m4a、aac</p>
                    <!--视频版-是否生成字幕-->
                    <!--                    <div class="subtitles_box" v-show="form.select_version==='1'">-->
                    <!--                      <span>是否生成字幕</span>-->
                    <!--                      <el-select v-model="form.subtitles" placeholder="请选择">-->
                    <!--                        <el-option-->
                    <!--                            v-for="item in subtitles_options"-->
                    <!--                            :key="item.value"-->
                    <!--                            :label="item.label"-->
                    <!--                            :value="item.value">-->
                    <!--                        </el-option>-->
                    <!--                      </el-select>-->
                    <!--                    </div>-->
                  </div>
                </div>


              </div>

              <div class="box_content_2" v-show="form.select_version === '2'">
                <!--图文版-背景图片上传-->
                <span class="upload_title">背景图片</span>
                <div class="upload_box_bgPic">
                  <el-upload
                      class="upload-demo"
                      action="/api/common/upload"
                      :on-remove="delBgPicFile"
                      :file-list="bgPicFileList"
                      :before-upload="beforeUploadBgPic"
                      :on-success="uploadBgPicSuccess"
                      :headers="headers"
                      list-type="picture">
                    <el-button size="small" type="primary" style="width: 200px">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                </div>
                <!--图文版-是否生成字幕-->
                <!--                <div class="subtitles_box" v-show="form.select_version==='2'">-->
                <!--                  <span>是否生成字幕</span>-->
                <!--                  <el-select v-model="form.subtitles" placeholder="请选择">-->
                <!--                    <el-option-->
                <!--                        v-for="item in subtitles_options"-->
                <!--                        :key="item.value"-->
                <!--                        :label="item.label"-->
                <!--                        :value="item.value">-->
                <!--                    </el-option>-->
                <!--                  </el-select>-->
                <!--                </div>-->

              </div>

            </div>
            <div class="generated_title_box">
              <p class="from_title_new">视频预览</p>
            </div>
            <div class="result_box_1">
              <div class="content_box">
                <video controls :src="result" v-show="result!== ''"></video>
              </div>
              <el-button type="primary" style="width: 85%" @click="submit">合成视频</el-button>
            </div>


          </div>
          <wordNav/>
        </div>
      </div>
    </div>
    <footerBot/>
  </div>
</template>

<script>
import wordNav from '@/components/wordNav.vue'
import ai_select from '@/components/ai_select.vue'
import ai_title from '@/components/ai_title.vue'
import ai_img from '@/components/ai_img'
import ai_switch from '@/components/ai_switch'
import ai_button_file_data from '@/components/ai_button_file_data'

export default {
  mounted() {
    this.getUserInfo()
  },
  components: {
    wordNav,
    ai_select,
    ai_title,
    ai_img,
    ai_switch,
    ai_button_file_data
  },
  data() {
    return {
      aiNumText: '',
      placeHolder: '',
      detail_placeHolder: '',
      form: {
        // 版本
        select_version: '2',
        // 录音文件
        recordingFile: '',
        // // 背景音乐文件
        // bgmFile: '',
        // 背景图片文件
        bgPicFile: '',
        // 是否生成字幕
        subtitles: '',
        // 背景视频文件
        bgVideoFile: ''
      },
      recordingFile_Name: '',
      // bgmFile_Name: '',
      bgPicFileList: [],
      bgVideoFile_Name: '',
      subtitles_options: [
        {
          value: 0,
          label: '否'
        },
        {
          value: 1,
          label: '是'
        }
      ],
      // 请求头
      headers: {
        token: '',
      },
      userInfo: {},
      //   生成结果
      result: ''
    }
  },
  methods: {
    // 图文、视频切换
    select_versionShow(id) {
      // 重置参数
      this.form = {
        // 版本
        select_version: '1',
        // 录音文件
        recordingFile: '',
        // // 背景音乐文件
        // bgmFile: '',
        // 背景图片文件
        bgPicFile: '',
        // 是否生成字幕
        subtitles: '',
        // 背景视频文件
        bgVideoFile: ''
      }
      this.form.select_version = id
      // 清空生成结果
      this.result = ''
      // console.log(this.form)
    },
    // 获取用户信息
    getUserInfo() {
      let $user_info = JSON.parse(localStorage.getItem('user_info'))
      if ($user_info) {
        this.curlGet('/api/user/info').then((res) => {
          if (res.data.code) {
            this.userInfo = res.data.data
            this.$user_info = res.data.data
            this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
            this.headers.token = res.data.data.token
          }
        })
      }
    },
    //   音频文件上传
    // 上传前的验证函数
    beforeUploadAudio(file) {
      const isAllowedType = this.checkFileType_audio(file);
      const isAllowedSize = this.checkFileSize_audio(file);
      return new Promise((resolve, reject) => {
        if (isAllowedType && isAllowedSize) {
          this.checkFileDuration(file)
              .then(() => {
                resolve(true);
              })
              .catch((error) => {
                this.$message.error(error);
                reject(false);
              });
        } else {
          if (!isAllowedType) {
            this.$message.error('仅支持 wav、mp3、wma、m4a、aac 格式的音频文件');
          }
          if (!isAllowedSize) {
            this.$message.error('文件大小不能超过 120 MB');
          }
          reject(false);
        }
      });
    },
    // 检查文件类型-音频
    checkFileType_audio(file) {
      console.log(file)
      const allowedTypes = ['audio/wav', 'audio/mp3', 'audio/mpeg', 'audio/wma', 'audio/m4a', 'audio/aac'];
      return allowedTypes.includes(file.type);
    },
    // 检查文件大小-音频
    checkFileSize_audio(file) {
      const maxSize = 120 * 1024 * 1024; // 120 MB
      return file.size <= maxSize;
    },
    // 检查文件时长-音频
    checkFileDuration(file) {
      return new Promise((resolve, reject) => {
        const audio = new Audio(URL.createObjectURL(file));
        audio.addEventListener('loadedmetadata', () => {
          const duration = audio.duration;
          if (duration <= 600) { // 10 分钟 = 600 秒
            resolve();
          } else {
            reject('音频时长不能超过 10 分钟');
          }
          URL.revokeObjectURL(audio.src);
        });
        audio.addEventListener('error', () => {
          reject('无法获取音频时长');
          URL.revokeObjectURL(audio.src);
        });
      });
    },
    // 上传成功的回调函数-录音文件
    uploadRecordingSuccess(res, file, fileList) {
      this.$message.success('音频上传成功');
      // console.log('文件上传成功', res, file, fileList);
      this.form.recordingFile = res.data.fullurl
      this.recordingFile_Name = file.name
      // console.log(this.form)
    },
    // 上传失败的回调函数-音频
    uploadAudioError(error, file, fileList) {
      this.$message.error('音频上传失败');
    },
    // uploadBGMSuccess(res, file, fileList) {
    //   this.$message.success('音频上传成功');
    //   console.log('文件上传成功', res, file, fileList);
    //   this.form.bgmFile = res.data.fullurl
    //   this.bgmFile_Name = file.name
    //   console.log(this.form)
    // },
    // 删除已上传的音频文件-录音文件
    changeRecordingFile() {
      this.$confirm('是否删除已上传的音频文件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.recordingFile = ''
        this.recordingFile_Name = ''
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // // 删除已上传的音频文件-背景音乐
    // changeBGMFile() {
    //   this.$confirm('是否删除已上传的音频文件？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.form.bgmFile = ''
    //     this.bgmFile_Name = ''
    //     this.$message({
    //       type: 'success',
    //       message: '删除成功!'
    //     });
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });
    // },


    //   背景图片上传
    // 上传前的验证函数
    beforeUploadBgPic(file) {
      const isAllowedType = this.checkFileType_pic(file);
      const isAllowedSize = this.checkFileSize_pic(file);
      return new Promise((resolve, reject) => {
        if (isAllowedType && isAllowedSize) {
          resolve(true);
        } else {
          if (!isAllowedType) {
            this.$message.error('仅支持 png、jpg、jpeg、bmp 格式的图片文件');
            reject(false);
          } else if (!isAllowedSize) {
            this.$message.error('文件大小不能超过 500 kb');
            reject(false);
          }

        }
      });
    },
    // 检查文件类型-图片
    checkFileType_pic(file) {
      const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/bmp'];
      return allowedTypes.includes(file.type);
    },
    // 检查文件大小-图片
    checkFileSize_pic(file) {
      const maxSize = 0.5 * 1024 * 1024; // 0.5 MB
      return file.size <= maxSize;
    },
    // 上传成功的回调函数-图片
    uploadBgPicSuccess(res, file, fileList) {
      this.$message.success('背景图片上传成功');
      this.bgPicFileList.push({
        name: file.name,
        url: res.data.fullurl
      })
    },

    // 删除已上传的背景图片文件
    delBgPicFile(file, fileList) {
      console.log(file.uid)
      this.bgPicFileList = this.bgPicFileList.filter((item) => {
        return item.uid !== file.uid;
      })
    },


    // 背景视频上传
    // 上传前的验证函数
    beforeUploadBgVideo(file) {
      const isAllowedType = this.checkFileType_video(file);
      const isAllowedSize = this.checkFileSize_video(file);
      return new Promise((resolve, reject) => {
        if (isAllowedType && isAllowedSize) {
          resolve(true);
        } else {
          if (!isAllowedType) {
            this.$message.error('仅支持 mp4 和 wmv 格式的视频文件');
          }
          if (!isAllowedSize) {
            this.$message.error('文件大小不能超过 500 MB');
          }
          reject(false);
        }
      });
    },
    // 检查文件类型-视频
    checkFileType_video(file) {
      const allowedTypes = ['video/mp4', 'video/x-ms-wmv'];
      return allowedTypes.includes(file.type);
    },
    // 检查文件大小-视频
    checkFileSize_video(file) {
      const maxSize = 500 * 1024 * 1024; // 500 MB
      return file.size <= maxSize;
    },
    // 上传成功的回调函数-视频
    uploadBgVideoSuccess(res, file, fileList) {
      this.$message.success('背景视频上传成功');
      this.form.bgVideoFile = res.data.fullurl;
      this.bgVideoFile_Name = file.name;
    },
    // 上传失败的回调函数-视频
    uploadBgVideoError(error, file, fileList) {
      this.$message.error('背景视频上传失败');
    },
    // 删除已上传的背景视频文件
    changeBgVideoFile() {
      this.$confirm('是否删除已上传的背景视频文件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.bgVideoFile = ''
        this.bgVideoFile_Name = ''
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 合成视频
    submit() {
      console.log(this.bgPicFileList)
      if (this.form.select_version === '1') {
        //   视频版
        let data = {
          mobile: this.userInfo.mobile,
          video_url: this.form.bgVideoFile,
          audio_url: this.form.recordingFile
        }
        this.curlPost('/file/create_composevideo', data).then(res => {
          console.log(res)
          if (res.data.code === 1) {
            this.result = res.data.data.output_content
            this.$message({
              type: 'success',
              message: '生成成功'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.msg
            })
          }
        })
      } else if (this.form.select_version === '2') {
        //   图文版
        let image_url = []
        this.bgPicFileList.forEach(item => {
          image_url.push(item.url)
        })
        let data = {
          mobile: this.userInfo.mobile,
          image_url: image_url,
          audio_url: this.form.recordingFile
        }
        this.curlPost('/file/create_composepicture', data).then(res => {
          console.log(res)
          if (res.data.code === 1) {
            this.result = res.data.data.output_content
            this.$message({
              type: 'success',
              message: '生成成功'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.msg
            })
          }
        })
      }
    }
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/ai';
</style>